import React, { useState, useCallback, useRef } from "react";
import Webcam from "react-webcam";
import cx from "classnames";
import styles from "./TakePhotoCamera.module.css";
import { base64ToFile } from "../../../utils/utils";

const FACING_MODE_USER = "user";
const FACING_MODE_ENVIRONMENT = "environment";

// HIGH QUALITY video constraints for react-webcam 7.2.0
const getVideoConstraints = (facingMode) => ({
  width: { ideal: 1920, min: 1280 },
  height: { ideal: 1080, min: 720 },
  facingMode,
  aspectRatio: 16 / 9,
  frameRate: { ideal: 30, min: 15 },
});

export default function TakePhotoCamera({ onCapture = () => undefined }) {
  const webcamRef = useRef(null);
  const [facingMode, setFacingMode] = useState(FACING_MODE_USER);
  const [captureImage, setCaptureImage] = useState("");

  const handleChangeFacing = useCallback(() => {
    setFacingMode((prevState) =>
      prevState === FACING_MODE_USER
        ? FACING_MODE_ENVIRONMENT
        : FACING_MODE_USER
    );
  }, []);

  const handleClickCapture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot({
      quality: 0.95,
    });

    setCaptureImage(imageSrc);
  }, [webcamRef]);

  const handleDeleteCapture = () => {
    setCaptureImage("");
  };

  const handleSaveCapture = () => {
    const fileUpload = base64ToFile(
      captureImage,
      `photo_${Date.now()}.jpeg`,
      "image/jpeg"
    );
    const filePreview = captureImage;

    onCapture({
      file: fileUpload,
      preview: filePreview,
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperCamera}>
        {captureImage ? (
          <img src={captureImage} alt="" />
        ) : (
          <Webcam
            audio={false}
            screenshotFormat="image/jpeg"
            screenshotQuality={0.95}
            videoConstraints={getVideoConstraints(facingMode)}
            ref={webcamRef}
            className={styles.webcam}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        )}
      </div>
      <div className={styles.wrapperAction}>
        <div
          className={cx(
            !captureImage && styles.visibilityHidden,
            styles.buttonHelp
          )}
          onClick={handleDeleteCapture}
        >
          <i className="fas fa-times"></i>
        </div>
        <div
          className={cx(
            captureImage && styles.visibilityHidden,
            styles.buttonTake
          )}
          onClick={handleClickCapture}
        >
          <div className={styles.buttonTakeSmall}></div>
        </div>
        <div
          className={cx(styles.buttonHelp)}
          onClick={() =>
            captureImage ? handleSaveCapture() : handleChangeFacing()
          }
        >
          {captureImage ? (
            <i className="fas fa-check"></i>
          ) : (
            <i className="fas fa-sync-alt"></i>
          )}
        </div>
      </div>
    </div>
  );
}
